document.querySelectorAll('.crossfade-container').forEach((container) => {
  const images = container.querySelectorAll('img');
  if (images.length < 2) return;

  let current = 0;

  setInterval(() => {
    images[current].style.opacity = 0;
    current = (current + 1) % images.length;
    images[current].style.opacity = 1;
  }, 4000);
});
